
// Ugly but works :D

import * as T from './Title';
import * as D from './Description';
import * as GD from './GraphDescription';

export class Title extends T.default {};
export class Description extends D.default {};
export class GraphDescription extends GD.default {};



/** WEBPACK FOOTER **
 ** ./src/components/H1BGraph/Meta/index.js
 **/